// extracted by mini-css-extract-plugin
module.exports = {"NavbarLink":"NavbarLink_NavbarLink__1hFcn","text":"NavbarLink_text__SLkEC","menuContent":"NavbarLink_menuContent__1Y-Cy","popMenu":"NavbarLink_popMenu__1DVcn"};